export function getSpectrumErrorValue(datum) {
    const { x } = datum.data;
    return (x[x.length - 1] - x[0]) / 10000;
}
